<template>
	<div class="content login-page">
		<div class="md-layout">
			<div class="md-layout-item md-medium-size-10 md-size-33"></div>
			<div class="md-layout-item md-medium-size-80 md-size-33 middle">
				<div class="md-layout">
					<div class="md-layout-item md-medium-size-100 md-size-100">
						<div style="display: flex; justify-content: center;">
							<img src="@/assets/img/logo.png" style="width: 60%; min-width: 300px; max-width: 500px;">
						</div>
						<md-card class="card">
							<md-card-content>
								<form>
									<div class="md-layout">
										<div class="md-layout-item md-small-size-100 md-size-100">
											<h4><b>{{translate(locale.loginSystem)}} {{translate(locale.singleId)}}</b></h4>
										</div>
										<div class="md-layout-item md-size-100 text-right">
											<md-button class="md-raised md-primary" style="width: 100%"
												@click="getLogin()">{{translate(locale.login)}}</md-button>
										</div>
									</div>
								</form>
							</md-card-content>
						</md-card>
					</div>
					<div class="md-layout-item md-medium-size-100 md-size-100">
						<div class="md-layout-item md-small-size-100 md-size-100 text-center">
							<a href="https://t.me/MISTISupport_bot" target="_blank"><span
									style="color:#FFF">{{translate(locale.technicalSupport)}}</span></a>
						</div>
					</div>
				</div>
			</div>
			<div class="md-layout-item md-medium-size-25 md-size-33"></div>
		</div>
	</div>
</template>

<script>
	export default {
		created() {
			if(String(this.$store.state.authentication.authToken).length > 10) this.$router.push("/");
		},
		methods: {
			getLogin() {
				this.$http.get(this.config.api + "/admin/get_login").then(res => {

					if (res.body.status == 'success') {
						window.location.replace(res.body.data.redirect_url);
					}
				})
			}
		}
	}
</script>

<style scoped>
	.card {
		margin-top: 40px;
	}

	.middle {
		position: relative;
		margin-top: 20vh;
	}

	.login-page {
		background-color: #353690;
		position: absolute;
		width: 100%;
		height: 100%;
	}
</style>


// WEBPACK FOOTER //
// src/pages/Login.vue